import { max } from 'lodash';
import { DRAG_AND_DROP_STATE_ACTION } from '../../../../features/analyses/Freeform/FreeformAnalysisForm/FreeformAnalysisFormUtil/dragAndDropReducer';
import { SECTION_STATE_ACTION } from '../../../../features/analyses/Freeform/FreeformAnalysisForm/FreeformAnalysisFormUtil/sectionsReducer';

const updateRichTextItem = (
  richTextId,
  richTextData,
  sections,
  linkedObjects
) =>
  sections.map((s) => {
    return {
      ...s,
      items: s.items.map((item) => {
        if (item.id === richTextId) {
          return {
            ...item,
            isShared: false,
            data: richTextData,
            ChildLibraryItems: linkedObjects.map((o) => o.id),
            richTextContent: {
              richTextData,
            },
          };
        }
        return item;
      }),
    };
  });

const updateNonLaidOutLibraryItems = (state, libraryItemId, moveDown) => {
  const currentSection = state.currentSections.find((s) =>
    s.items.map((i) => i.id).includes(libraryItemId)
  );

  if (currentSection) {
    if (!moveDown && currentSection.order === 1) {
      const itemToMove = currentSection.items.find(
        (i) => i.id === libraryItemId
      );
      return [itemToMove].concat(state.nonLaidOutLibraryItems);
    }
  }
  return state.nonLaidOutLibraryItems;
};

const updateCurrentSections = (state, libraryItemId, moveDown) => {
  const currentSection = state.currentSections.find((s) =>
    s.items.map((i) => i.id).includes(libraryItemId)
  );

  if (!currentSection) return state.currentSections;

  const itemToMove = currentSection.items.find((i) => i.id === libraryItemId);
  itemToMove.analysisColumn = 1;

  if (!moveDown && currentSection.order === 1) {
    return state.currentSections.map((s) => {
      return {
        ...s,
        items: s.items.filter((item) => item.id !== itemToMove.id),
      };
    });
  }

  const newSectionIsValid = moveDown
    ? currentSection.order < max(state.currentSections.map((s) => s.order))
    : currentSection.order > 1;
  if (newSectionIsValid) {
    const newSectionNumber = moveDown
      ? currentSection.order + 1
      : currentSection.order - 1;
    const newSections = state.currentSections.map((s) => {
      let newItems = s.items;

      if (s.order === newSectionNumber) {
        if (moveDown) {
          newItems = newItems.concat([itemToMove]).map((item) => {
            const newOrder = item.id === itemToMove.id ? 1 : item.order + 1;
            return {
              ...item,
              order: newOrder,
            };
          });
        } else {
          const newOrder = 1 + max(s.items.map((i) => i.order));
          const itemWithNewOrder = { ...itemToMove, order: newOrder };
          newItems = s.items.concat([itemWithNewOrder]);
        }
      } else if (s.order === currentSection.order) {
        newItems = s.items.filter((i) => i.id !== libraryItemId);
      }
      return {
        ...s,
        items: newItems,
      };
    });
    return newSections;
  }

  return state.currentSections;
};

const removeNonLaidOutItemsFromSections = (sections, nonLaidOutItems) => {
  const itemIdsToRemove = nonLaidOutItems.map((item) => item.id);
  return sections.map((s) => {
    return {
      ...s,
      items: s.items.filter((item) => !itemIdsToRemove.includes(item.id)),
    };
  });
};

const sectionsReducer = (state, { type, payload }) => {
  switch (type) {
    case SECTION_STATE_ACTION.UPDATE_SECTIONS:
      return {
        ...state,
        currentSections: payload,
      };
    case SECTION_STATE_ACTION.UPDATE_RICH_TEXT:
      return {
        ...state,
        currentSections: updateRichTextItem(
          payload.libraryItemId,
          payload.richText,
          state.currentSections,
          payload.linkedObjects
        ),
      };
    case DRAG_AND_DROP_STATE_ACTION.ITEM_MOVED_TO_ADJACENT_AREA: {
      const { newAnalysisColumn, libraryItemId } = payload;
      const newCurrentSections = state.currentSections.map((s) => {
        const newItems = s.items.map((i) => {
          if (i.id === libraryItemId) {
            const newAnalysisColumnInt = parseInt(newAnalysisColumn, 10);
            i.analysisColumn = Number.isInteger(newAnalysisColumnInt)
              ? newAnalysisColumnInt
              : 1;
          }
          return i;
        });
        return {
          ...s,
          items: newItems,
        };
      });
      return {
        ...state,
        currentSections: newCurrentSections,
      };
    }
    case DRAG_AND_DROP_STATE_ACTION.ITEM_MOVED_UP_TO_NEW_SECTION: {
      const nonLaidOutLibraryItems = updateNonLaidOutLibraryItems(
        state,
        payload.libraryItemId,
        false
      );
      const currentSections = updateCurrentSections(
        state,
        payload.libraryItemId,
        false
      );
      return {
        ...state,
        nonLaidOutLibraryItems,
        currentSections,
      };
    }
    case DRAG_AND_DROP_STATE_ACTION.ITEM_MOVED_DOWN_TO_NEW_SECTION: {
      const nonLaidOutLibraryItems = updateNonLaidOutLibraryItems(
        state,
        payload.libraryItemId,
        true
      );
      const currentSections = updateCurrentSections(
        state,
        payload.libraryItemId,
        true
      );
      return {
        ...state,
        nonLaidOutLibraryItems,
        currentSections,
      };
    }
    case SECTION_STATE_ACTION.UPDATE_NON_LAID_OUT_LIBRARY_ITEMS: {
      return {
        ...state,
        nonLaidOutLibraryItems: payload.items,
        currentSections: removeNonLaidOutItemsFromSections(
          state.currentSections,
          payload.items
        ),
      };
    }
    case SECTION_STATE_ACTION.ITEM_DELETED: {
      return {
        ...state,
        nonLaidOutLibraryItems: state.nonLaidOutLibraryItems.filter(
          (item) => item.id !== payload
        ),
      };
    }
    case SECTION_STATE_ACTION.SECTION_TO_SCROLL: {
      return {
        ...state,
        sectionIdToScroll: payload,
      };
    }
    case SECTION_STATE_ACTION.ITEM_TO_ADD: {
      return {
        ...state,
        locationToAdd: payload,
      };
    }
    case SECTION_STATE_ACTION.ITEM_TO_ADD_CLEAR: {
      return {
        ...state,
        locationToAdd: undefined,
      };
    }
    default:
      return state;
  }
};

export default sectionsReducer;
